<template>
  <div>
    <AppHeader />

    <section class="legal-hero">
      <div class="container">
        <h1>Пользовательское соглашение</h1>
        <p class="legal-updated">Редакция от {{ updated }}</p>
      </div>
    </section>

    <section class="legal-content">
      <div class="container legal-container">
        <p class="legal-lead">
          Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения
          между Индивидуальным предпринимателем Мищенко Алиной Сергеевной (далее — «Исполнитель»,
          «Оператор») и физическим лицом (далее — «Пользователь»), использующим сайт
          «Мама, я в Китае».
        </p>

        <ol>
          <li>
            <h2>Предмет Соглашения</h2>
            <ol>
              <li>Исполнитель предоставляет Пользователю возможность использовать сайт для ознакомления с услугами, записи на занятия и доступа к образовательным материалам.</li>
              <li>Использование сайта возможно только при условии согласия Пользователя с условиями настоящего Соглашения.</li>
            </ol>
          </li>

          <li>
            <h2>Регистрация и учётная запись</h2>
            <ol>
              <li>Для доступа к личному кабинету Пользователь проходит регистрацию, указывая достоверные сведения (имя, фамилия, адрес электронной почты).</li>
              <li>Пользователь несёт ответственность за достоверность предоставленных данных и безопасность своих учётных данных (логина и пароля).</li>
              <li>Регистрируясь, Пользователь подтверждает своё согласие на обработку персональных данных согласно <router-link to="/privacy">Политике конфиденциальности</router-link>.</li>
            </ol>
          </li>

          <li>
            <h2>Использование сайта</h2>
            <ol>
              <li>Пользователь обязуется не нарушать законодательство РФ и не причинять ущерб Исполнителю и иным лицам.</li>
              <li>Запрещается: распространять недостоверную информацию; нарушать работу сайта; пытаться получить несанкционированный доступ к данным; использовать автоматические средства сбора данных без согласия Исполнителя.</li>
              <li>Интеллектуальная собственность на материалы сайта (тексты, изображения, видео, методики) принадлежит Исполнителю. Использование материалов без согласия Исполнителя запрещено.</li>
            </ol>
          </li>

          <li>
            <h2>Оказание услуг и оплата</h2>
            <ol>
              <li>Условия оказания образовательных услуг, стоимость и порядок оплаты определяются отдельными страницами сайта, тарифами и договорами с Пользователем.</li>
              <li>Порядок возврата денежных средств определяется законодательством РФ и условиями оказания услуг.</li>
            </ol>
          </li>

          <li>
            <h2>Файлы cookie и аналитика</h2>
            <p>
              Сайт использует файлы cookie и технологии веб-аналитики для обеспечения работы
              сайта, сохранения настроек и сбора статистики посещений. Используя сайт,
              Пользователь соглашается с использованием cookie. Пользователь может управлять
              cookie в настройках браузера, а также согласиться или отклонить их через
              уведомление при первом посещении сайта. Подробнее об обработке данных — в
              <router-link to="/privacy">Политике конфиденциальности</router-link>.
            </p>
          </li>

          <li>
            <h2>Ответственность сторон</h2>
            <ol>
              <li>Исполнитель не гарантирует бесперебойную работу сайта в случае обстоятельств непреодолимой силы и технических сбоев у третьих лиц.</li>
              <li>Пользователь несёт ответственность за действия, совершённые с использованием его учётной записи.</li>
            </ol>
          </li>

          <li>
            <h2>Изменение Соглашения</h2>
            <p>
              Исполнитель вправе в одностороннем порядке изменять настоящее Соглашение.
              Актуальная версия размещается на данной странице. Продолжение использования сайта
              после внесения изменений означает согласие Пользователя с обновлённой редакцией.
            </p>
          </li>

          <li>
            <h2>Реквизиты и контакты</h2>
            <ul>
              <li>ИП Мищенко Алина Сергеевна</li>
              <li>ИНН 545328832110</li>
              <li>ОГРНИП 323547600086166</li>
              <li>через форму на странице <router-link to="/contacts">Контакты</router-link>.</li>
            </ul>
          </li>
        </ol>
      </div>
    </section>

    <UIFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import UIFooter from '@/components/ui/UIFooter.vue'

export default {
  name: 'TermsPage',
  components: { AppHeader, UIFooter },
  data() {
    return { updated: '01.07.2026' }
  }
}
</script>

<style scoped>
.legal-hero {
  background: radial-gradient(circle at top, rgba(231, 76, 60, 0.12), transparent 60%), #f5f1ef;
  padding: 120px 0 40px;
  text-align: center;
}
.legal-hero h1 {
  font-size: 2.2rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 8px;
}
.legal-updated { color: #6c757d; font-size: 0.95rem; }
.legal-content { padding: 48px 0 72px; background: #fff; }
.legal-container { max-width: 820px; }
.legal-lead { font-size: 1.05rem; color: #495057; margin-bottom: 1.5rem; }
.legal-content h2 { font-size: 1.25rem; font-weight: 700; color: #2c3e50; margin: 0 0 0.5rem; }
.legal-container > ol { counter-reset: legal; padding-left: 0; list-style: none; }
.legal-container > ol > li { position: relative; padding-left: 40px; margin-bottom: 1.75rem; }
.legal-container > ol > li::before {
  counter-increment: legal;
  content: counter(legal);
  position: absolute;
  left: 0;
  top: 0;
  width: 28px; height: 28px; line-height: 28px; text-align: center;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: #fff; border-radius: 50%;
  font-size: 0.85rem; font-weight: 700;
}
.legal-content ol ol { padding-left: 1.5rem; margin-top: 0.5rem; list-style: decimal; }
.legal-content ol ol > li { position: static; padding-left: 0; margin-bottom: 0.5rem; }
.legal-content ol ol > li::before { display: none; }
.legal-content ul { margin: 0.5rem 0 0.5rem 1.25rem; }
.legal-content li { color: #495057; line-height: 1.7; }
.legal-content a { color: #e74c3c; text-decoration: none; }
.legal-content a:hover { text-decoration: underline; }
</style>
